// extracted by mini-css-extract-plugin
module.exports = {"shortcut":"KeyboardShortcutsModalContent-shortcut-1yFBm","key":"KeyboardShortcutsModalContent-key-26dNy"};